// extracted by mini-css-extract-plugin
export default {"root":"PlayButton_root__HYP7s","playIcon":"PlayButton_playIcon__TvSH5","pauseIcon":"PlayButton_pauseIcon__Axio1"};